import '/public/static/css/module/tab_list_item.scss';
import {SectionHeader} from '@/components/main/common';
import {SoopUiSelectBox} from '@/components/ui';
import {DIRECTORY_CONTENT_SORT_OPTION} from '@/constants/main';
import {useEffect, useRef, useState} from 'react';
import {useOutsideClick} from '../../common/hooks/useOutsideClick';
import useDirectoryStore from '@/stores/directory';
import SoopUiDatePicker from '@/components/ui/soop-ui-date-picker/SoopUiDatePicker';
import {sendClickLog} from '@/utils/main/my-plus/log';

const getItemsByTab = (tab) => {
  if (tab) {
    const option = DIRECTORY_CONTENT_SORT_OPTION.find(
      (option) => option.type === tab,
    );

    if (tab === 'live') {
      return option ? option.items : [];
    } else {
      return option;
    }
  }
};

const LIST_TAB = [
  {key: 'live', label: 'LIVE'},
  {key: 'vod', label: 'VOD'},
  {key: 'catch', label: 'Catch'},
];

export const ListTab = ({
  order,
  categoryInfo,
  handleOnClickTab,
  handleOnClickSort,
  handleVodFilterClick,
}) => {
  const [isFilterShow, setIsFilterShow] = useState(false); //vod, catch 필터 노출여부
  const {
    selectedCategoryTab,
    selectedContentFilter,
    selectedPeriodFilter,
    setSelectedPeriodFilter,
  } = useDirectoryStore();

  const filterRef = useRef(null);
  const calenderRef = useRef(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  //LIVE VOD CATCH 어드민 설정에 의해 노출/비노출 여부 확인
  const showRenderTab = (item) => {
    if (categoryInfo) {
      if (item.key === 'live' && !categoryInfo.contentsDisplay?.live) {
        return false;
      } else if (item.key === 'vod' && !categoryInfo.contentsDisplay?.vod) {
        return false;
      } else if (item.key === 'catch' && !categoryInfo.contentsDisplay?.catch) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };

  useOutsideClick(filterRef, () => {
    if (selectedCategoryTab === 'live') {
      setIsFilterShow(false);
    }
  });

  const isActiveFilter = (key, type) => {
    if (key === 'period') {
      return selectedPeriodFilter.type === type;
    }
    return selectedContentFilter[selectedCategoryTab].some(
      (filter) => filter.key === key && filter.type === type,
    );
  };

  useEffect(() => {
    setIsFilterShow(false);
    setStartDate('');
    setEndDate('');
  }, [selectedCategoryTab]);

  // 클릭로그
  // 호출시점 1) (날짜 미적용 시) 직접 입력 클릭 후 > 날짜 적용 시점'
  // 호출시점 2) (날짜 적용 시) 직접 입력 클릭 후
  const handleSendClickLog = () => {
    sendClickLog(categoryInfo?.type === 'admin' ? 'admin' : 'cate', {
      buttonType: 'period_select',
      buttonGroup:
        selectedCategoryTab === 'vod' ? 'vod_filter' : 'catch_filter',
      contentsType: 'vod',
    });
  };

  // 캘린더의 적용버튼 눌럿을 때 실행되는 로직
  const handleDateSelected = ({startDate, endDate, key, label, type}) => {
    setStartDate(startDate);
    setEndDate(endDate);

    // 직접입력 활성화 상태 체크
    const isDirectInputState = selectedPeriodFilter.type === 'directInput';

    if (!isDirectInputState) {
      handleSendClickLog();
      handleVodFilterClick(key, label, type);
    }
  };

  /**
   * 직접입력 클릭 핸들러
   * (기간 선택 X): 캘린더 노출
   * (기간 선택 O): 해당 기간으로 API 조회
   */
  const handleDirectInputClicked = (key, label, type) => {
    if (!startDate) {
      calenderRef?.current?.open();
    } else {
      handleVodFilterClick(key, label, type);
      setSelectedPeriodFilter({
        ...selectedPeriodFilter,
        label: '직접입력',
        type: 'directInput',
        applyStatus: true,
      });
      handleSendClickLog();
    }
  };

  const handleFilterHide = () => {
    setIsFilterShow(!isFilterShow);
    if (!isFilterShow && calenderRef.current) {
      calenderRef.current.close();
    }
  };

  useEffect(() => {
    if (!startDate && !endDate) {
      return;
    }
    setSelectedPeriodFilter({
      ...selectedPeriodFilter,
      startDate: startDate,
      endDate: endDate,
      applyStatus: true,
    });
  }, [startDate, endDate]);

  return (
    <>
      {
        <div className='tab_list_item category'>
          <ul>
            {LIST_TAB.filter(showRenderTab).map((item, idx) => (
              <li
                key={idx}
                className={`${selectedCategoryTab === `${item.key}` ? 'on' : ''}`}>
                <button
                  type='button'
                  onClick={() => handleOnClickTab(`${item.key}`)}>
                  <span>{item.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      }
      {!!selectedCategoryTab && (
        <div className='categoryRightArea'>
          {selectedCategoryTab === 'live' ? (
            <SoopUiSelectBox
              options={getItemsByTab(selectedCategoryTab)}
              type={order}
              onChange={handleOnClickSort}
            />
          ) : (
            <div className={`select_box_item ${isFilterShow ? 'on' : ''}`}>
              <button
                type='button'
                className='selected'
                onClick={() => {
                  setIsFilterShow(!isFilterShow);
                }}>
                {selectedContentFilter[selectedCategoryTab].map(
                  (filter, idx) =>
                    (selectedCategoryTab !== 'catch' ||
                      filter.key !== 'fileType') && (
                      <span key={idx} className='item'>
                        {filter.label}
                      </span>
                    ),
                )}
                <span>{selectedPeriodFilter.label}</span>
              </button>
            </div>
          )}
        </div>
      )}
      {selectedCategoryTab !== 'live' && (
        <div
          className={`select_filter_list ${isFilterShow ? 'active' : ''}`}
          ref={filterRef}>
          {getItemsByTab(selectedCategoryTab)?.items.map((filter, index) => (
            <dl key={index}>
              <dt>{filter.title}</dt>
              <dd>
                <ul>
                  {filter.item.map((option, idx) =>
                    option.type !== 'directInput' ? (
                      <li
                        key={idx}
                        className={
                          isActiveFilter(filter.key, option.type)
                            ? 'active'
                            : ''
                        }
                        onClick={() => {
                          handleVodFilterClick(
                            filter.key,
                            option.label,
                            option.type,
                          );
                        }}>
                        <button type='button'>{option.label}</button>
                      </li>
                    ) : (
                      <li
                        key={idx}
                        className={`direct ${
                          isActiveFilter(filter.key, option.type)
                            ? 'active'
                            : ''
                        }`}>
                        <button
                          type='button'
                          onClick={() => {
                            handleDirectInputClicked(
                              filter.key,
                              option.label,
                              option.type,
                            );
                          }}>
                          직접입력
                        </button>
                        <SoopUiDatePicker
                          ref={calenderRef}
                          startDate={startDate}
                          endDate={endDate}
                          handleDateSelected={({startDate, endDate}) => {
                            handleDateSelected({
                              startDate,
                              endDate,
                              key: filter.key,
                              label: option.label,
                              type: option.type,
                            });
                          }}
                        />
                      </li>
                    ),
                  )}
                </ul>
              </dd>
            </dl>
          ))}
          <button
            type='button'
            className='btn_close'
            onClick={handleFilterHide}>
            레이어 닫기
          </button>
        </div>
      )}
    </>
  );
};

export default ListTab;
